// import 'svgxuse'; // Uncomment to support svg icons on IE

import { createPopper } from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import './components/header'
import './components/loadmore'
import './components/smooth-scroll'
import './components/sliders'
import './components/alert-bar'
import './blocks/team'

// BS Tooltip init
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// BS Scrollspy init
const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#js-scrollspy',
  rootMargin: '0px 0px -75% 0px',
})
